var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getCurIndex>-1)?_c('vSteps',{staticClass:"bg-fff padding-20 inbound-steps",attrs:{"current":_vm.getCurIndex}},_vm._l((_vm.progressStatus),function(val,key){return _c('vStep',{key:key,attrs:{"title":val.name}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }